import request from '@/utils/request'

/**
 * 查询签到规则列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function querySignRule(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sign.querySignRule',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存签到规则
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveSignRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sign.saveSignRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新签到规则
 * @param {Object} data 更新数据
 * @returns {Promise} Promise对象
 */
export function updateSignRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sign.updateSignRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除签到规则
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteSignRule(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sign.deleteSignRule',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
